import React from 'react'
import {RigidBody, CuboidCollider} from '@react-three/rapier'
import {useGame} from '../contexts/GameContext'
import {useGLTF} from '@react-three/drei'
import * as THREE from 'three'

const GOAL_WIDTH = 3
const GOAL_HEIGHT = 2.14
const POST_THICKNESS = 0.25
const GOAL_X = 0
const GOAL_Z = 0

// Добавляем проп lastShotWasHit
interface GoalProps {
  lastShotWasHit?: React.MutableRefObject<boolean>
}

export const Goal: React.FC<GoalProps> = ({ lastShotWasHit }) => {
    const {incrementScore, setCrossbarHit} = useGame()
    const {scene} = useGLTF('/models/goal.glb')

    // Utility: remove all invisible or unwanted meshes from the loaded scene
    function removeInvisibleObjects(object: THREE.Object3D) {
        object.traverse((child) => {
            // Remove if invisible or by name pattern (add more conditions if needed)
            if (!child.visible || (child.name && /helper|invisible|dummy/i.test(child.name))) {
                if (child.parent) {
                    child.parent.remove(child)
                }
            }
        })
    }
    removeInvisibleObjects(scene)

    const handleCrossbarHit = () => {
        incrementScore()
        setCrossbarHit(true)
        if (lastShotWasHit) lastShotWasHit.current = true // <--- фикс
    }

    return (
        <group position={[GOAL_X, 0, GOAL_Z]}>
            {/* Visual goal model, perfectly aligned and scaled */}
            <RigidBody type="fixed" position={[0, 0, -15]} restitution={0} rotation={[0, Math.PI / 2, 0]}>
                <primitive object={scene} scale={1} />
            </RigidBody>

            <RigidBody type="fixed" position={[0, GOAL_HEIGHT, -3.8]} restitution={1} onCollisionEnter={handleCrossbarHit}>
                <CuboidCollider args={[GOAL_WIDTH / 2, POST_THICKNESS / 2, POST_THICKNESS / 2]} />
            </RigidBody>
        </group>
    )
}

// Required for GLTF loading
useGLTF.preload('/models/goal.glb') 